var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#C83D2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2173 12C15.8321 12 13.5 14.8101 13.5 17.8743C13.5 19.2953 14.294 21.0674 15.5651 21.6294C15.7581 21.7164 15.8631 21.6794 15.9061 21.5004C15.9441 21.3644 16.1111 20.7094 16.1921 20.4004C16.2171 20.3014 16.2041 20.2154 16.1241 20.1224C15.7021 19.6343 15.3671 18.7453 15.3671 17.9113C15.3671 15.7742 17.0662 13.6991 19.9573 13.6991C22.4574 13.6991 24.2065 15.3231 24.2065 17.6463C24.2065 20.2714 22.8174 22.0875 21.0123 22.0875C20.0133 22.0875 19.2693 21.3034 19.5053 20.3334C19.7903 19.1783 20.3493 17.9363 20.3493 17.1032C20.3493 16.3562 19.9273 15.7382 19.0652 15.7382C18.0482 15.7382 17.2232 16.7452 17.2232 18.0973C17.2232 18.9563 17.5272 19.5363 17.5272 19.5363C17.5272 19.5363 16.5211 23.6005 16.3341 24.3596C16.0181 25.6446 16.3771 27.7257 16.4081 27.9047C16.4271 28.0037 16.5381 28.0347 16.6001 27.9537C16.6991 27.8237 17.9152 26.0886 18.2562 24.8346C18.3802 24.3776 18.8892 22.5245 18.8892 22.5245C19.2243 23.1295 20.1913 23.6365 21.2213 23.6365C24.2855 23.6365 26.4996 20.9434 26.4996 17.6013C26.4886 14.3971 23.7465 12 20.2173 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/pn.5e8d398f7f1f101da1359a7663ecb725.svg";
export { ForwardRef as ReactComponent };